import { createSlice } from "@reduxjs/toolkit";

const ListDetailsSlice = createSlice({
  name: "listDetails",
  initialState: {
    selectedFilters: {},
    selectedDate: {},
    selectedAge: {},
    listName: "",
  },
  reducers: {
    updateSelectedFilters: (state, action) => {
      const { title, selectedOptions } = action.payload;
      state.selectedFilters[title] = selectedOptions;
    },
    updatedFilter: (state, action) => {
      state.selectedFilters = action.payload;
    },
    updateSelectedDate: (state, action) => {
      const { title, date, type } = action.payload;
      if (!state.selectedDate[title]) {
        state.selectedDate[title] = {};
      }
      state.selectedDate[title][type] = date;
    },
    updateSelectedAge: (state, action) => {
      const { title, age, type } = action.payload;
      if (!state.selectedAge[title]) {
        state.selectedAge[title] = {};
      }
      state.selectedAge[title][type] = age;
    },
    updateListName: (state, action) => {
      state.listName = action.payload;
    },
    clearListState: (state) => {
      state.selectedFilters = {};
      state.selectedDate = {};
      state.selectedAge = {};
      state.listName = "";
    },
  },
});

export const {
  updateSelectedFilters,
  updateSelectedDate,
  updateListName,
  clearListState,
  updatedFilter,
  updateSelectedAge,
} = ListDetailsSlice.actions;
export default ListDetailsSlice.reducer;
